<template>
    <b-row>
        <b-col cols="12">
            <h4 class="mb-2">
                <span>
                    {{ $t('general.abono', { abono: teatro.texto_abono.charAt(0).toUpperCase() + teatro.texto_abono.slice(1) }) }} {{ index + 1 }}
                </span>
            </h4>
        </b-col>
        <b-col cols="12">
            <b-row>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.name"
                        :id="'nombre-' + index"
                        rules="required"
                        :label="$t('formularios.nombre')"
                        :name="$t('formularios.nombre')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.lastName"
                        rules="required"
                        :id="'apellidos-' + index"
                        :label="$t('formularios.apellidos')"
                        :name="$t('formularios.apellidos')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <ValidationProvider name="genero" rules="required" v-slot="{ errors }">
                        <div class="form-group">
                            <label>{{ $t('formularios.genero') }}</label>
                            <multiselect
                                v-model="abono.gender_object"
                                label="name"
                                track-by="id"
                                class="custom-multiselect"
                                :class="(errors[0] ? 'is-invalid' : '')"
                                :id="'genero-' + index"
                                :placeholder="$t('formularios.genero')"
                                :options="generos"
                                @select="formatGender"
                            />
                            <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold" >
                                {{ errors[0] }}
                            </span>
                        </div>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <ValidationProvider name="tipo de documento" rules="required" v-slot="{ errors }">
                        <div class="form-group">
                            <label>{{ $t('formularios.tipo_identificacion') }}</label>
                            <multiselect
                                v-model="tipoDocumentoSeleccionado"
                                label="type"
                                track-by="type"
                                class="custom-multiselect"
                                :class="(errors[0] ? 'is-invalid' : '')"
                                :id="'tipo-documento-' + index"
                                :placeholder="$t('formularios.tipo_identificacion')"
                                :options="tiposDocumento"
                                @input="onSeleccionTipoDocumento"
                            />
                            <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold" >
                                {{ errors[0] }}
                            </span>
                        </div>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <FormInput
                            v-model="abono.identification.value"
                            :rules="{ required: true, identificacion: { tipo: abono.identification.type } }"
                            :id="'valor-documento-' + index"
                            :label="texto_documentacion"
                            :name="texto_documentacion"
                            :disabled="!abono.identification.type"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <Paises
                            :desactivar="false"
                            @rellenarPais="rellenarPais"
                            @selected="opt => { pais = opt; abono.address.country = opt.iso3; }"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <Provincias
                            :desactivar="false"
                            :pais="pais.id"
                            :provincia="provincia"
                            @selected="opt => { provincia = opt; abono.address.state = opt.nombre; }"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <Locations
                            :desactivar="false"
                            :provincia="provincia"
                            @selected="opt => { abono.address.city = opt.nombre; }"
                        />
                    </div>
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.address.zipCode"
                        rules="required"
                        :id="'cp-' + index"
                        :label="$t('formularios.cp')"
                        :name="$t('formularios.cp')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.address.streetLine1"
                        rules="required"
                        :id="'direccion-' + index"
                        :label="$t('formularios.domicilio')"
                        :name="$t('formularios.domicilio')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.birthday"
                        rules="required"
                        :id="'fecha-nacimiento-' + index"
                        type="date"
                        :label="$t('formularios.nacimiento')"
                        :name="$t('formularios.nacimiento')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.email"
                        rules="required"
                        :vid="'confirmation-' + index"
                        :id="'email-' + index"
                        type="email"
                        :label="$t('formularios.email')"
                        :name="$t('formularios.email')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <FormInput
                        v-model="abono.email_confirm"
                        :id="'email-confirm-' + index"
                        type="email"
                        :rules="'required|confirmed_ci:@confirmation-' + index"
                        :label="$t('formularios.confirmar_email')"
                        :name="$t('formularios.confirmar_email')"
                    />
                </b-col>
                <b-col cols="12" md="6" lg="4">
                    <div class="form-group">
                        <label :for="'telefono-' + index">{{ $t('formularios.telefono') }}</label>
                        <PhoneInput
                            :name="'telefono-' + index" 
                            :phone="abono.phone ?? null" 
                            :required="true"
                            :error_telefono="abono.error_telefono"
                            @setNumber="(number) => abono.phone = number"
                            @validNumber="(valid) => abono.isValidNumber = valid"
                        />
                    </div>
                </b-col>
                <b-col cols="12" class="mb-2">
                    <hr/>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
    import Provincias from "../../../../common/forms/Provincias";
    import Locations from "../../../../common/forms/Locations";
    import Paises from "../../../../common/forms/Paises";
    import PhoneInput from '@/components/common/PhoneInput';

    export default {
        props: {
            datos_abono: {
                type: Object,
                required: true
            },
            generos: {
                type: Array,
                required: true
            },
            index: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                provincia: null,
                pais: { id: 0 },
                texto_documentacion: 'seleccione el tipo de documento',
                tipoDocumentoSeleccionado: null,
                tiposDocumento: [
                    { type: "DNI", value: "" },
                    { type: "NIE", value: "" },
                    { type: "NIF", value: "" },
                    { type: "PASAPORTE", value: "" }
                ]
            };
        },
        methods: {
            rellenarPais(pais) {
                this.abono.address.country = pais.iso3;
            },
            getTipoIdentificacionValor(type) {
                return this.tiposDocumento.find(doc => doc.type === type) || null;
            },
            onSeleccionTipoDocumento(option) {
                this.tipoDocumentoSeleccionado = option;
                this.abono.identification.type = option?.type;
                this.setTextoDocumentacion();
            },
            formatGender(option) {
                switch (option.name) {
                    case 'Hombre':
                        this.abono.gender = 'MALE';
                        break;
                    case 'Mujer':
                        this.abono.gender = 'FEMALE';
                        break;
                    default:
                        this.abono.gender = 'OTHER';
                        break;
                }
            },
            setTextoDocumentacion() {
                switch (this.abono.identification?.type) {
                    case 'DNI':
                        this.texto_documentacion = this.$t('formularios.dni');
                        break;
                    case 'NIE':
                        this.texto_documentacion = this.$t('formularios.nie');
                        break;
                    case 'NIF':
                        this.texto_documentacion = this.$t('formularios.nif');
                        break;
                    case 'PASAPORTE':
                        this.texto_documentacion = this.$t('formularios.pasaporte');
                        break;
                    default:
                        this.texto_documentacion = this.$t('formularios.tipo_identificacion');
                        break;
                }
            }
        },
        computed: {
            abono: {
                get() {
                    return this.datos_abono;
                },
                set(value) {
                    this.$emit('update:datos_abono', value);
                }
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            esMovil() {
                return window.innerWidth <= 768;
            }
        },
        created() {
            if (this.teatro.provincia) {
                this.provincia = this.teatro.provincia;
            }
        },
        components: {
            Provincias, Paises, Locations, PhoneInput
        }
    }
</script>